<div class="dropdown" [ngClass]="componentClass">
  <ng-container *ngIf="multiSelectSearch">
    <div class="u-width-100" (click)="open($event)">
      <input
        class="u-width-100 dropdown__withpill"
        #selectSearch
        name="selectSearch"
        type="text"
        [placeholder]="placeholder"
        autocomplete="off"
      />
      <ls-pill [count]="pillCount()"></ls-pill>
      <i class="fa fa-caret-down" aria-hidden="true"></i>
    </div>
  </ng-container>
  <ng-container *ngIf="!multiSelectSearch">
    <button
      class="o-button o-button--default o-button--medium button__dropdown dropdown__withpill u-width-100"
      type="button"
      aria-haspopup="true"
      aria-expanded="true"
      #button
      (click)="toggle($event)"
    >
      {{ placeholder }}
      <ls-pill [count]="pillCount()"></ls-pill>
      <i class="fa fa-caret-down" aria-hidden="true"></i>
    </button>
  </ng-container>
  <div
    class="dropdown-backdrop"
    *ngIf="panelOpen"
    (click)="toggle($event)"
  ></div>
  <ul
    class="dropdown-menu"
    aria-labelledby="locationDropdown"
    *ngIf="panelOpen"
  >
    <li *ngIf="selectAll">
      <a (click)="selectAllItems($event)" class="dropdown-menu-item" href="#">
        <span
          class="u-color-info"
          i18n="multi-select-dropdown|An option to select all items in a multi-select dropdown @@multiSelectSelectAll"
          >Select all</span
        >
        <span class="u-color-info">({{ getItems().length }})</span>
      </a>
    </li>
    <li *ngFor="let item of getItems(); let i = index">
      <a
        href="#"
        #listItem
        class="dropdown-menu-item with-icon"
        (keydown)="handleKeyboardEvent($event.keyCode, $event)"
        (click)="select(item, $event)"
        [class.active]="isActive(i)"
        (mouseenter)="selectActive(i)"
      >
        {{ item.name }}
        <span
          class="u-float-right"
          [ngClass]="{
            'u-color-lighter': !isSelected(item),
            'u-color-info': isSelected(item)
          }"
        >
          <i class="fa fa-check" aria-hidden="true"></i>
        </span>
      </a>
    </li>
  </ul>
</div>
